'use client';
import { useEffect, useRef } from 'react';
import { useAmplitude } from './amplitude';
import { useStore } from '@/store/store';
import { useSnowplowUm } from '@/tracking/snowplow';

export type TrackingEvent = {
    destination: 'amplitude' | 'snowplow' | 'gtm';
    eventProps: any;
};

export const TrackingManager = () => {
    const { sendEventToAmplitude } = useAmplitude();
    const { sendEventToSnowplow } = useSnowplowUm();
    // const { sendEventToGTM } = useGTM();
    // ...
    const { setSendEvent } = useStore((state) => state.tracking);
    const sendEventToAmplitudeRef = useRef(sendEventToAmplitude);
    const sendEventToSnowplowRef = useRef(sendEventToSnowplow);

    sendEventToAmplitudeRef.current = sendEventToAmplitude;
    sendEventToSnowplowRef.current = sendEventToSnowplow;

    useEffect(() => {
        setSendEvent((events: TrackingEvent[]) => {
            events.forEach((event) => {
                switch (event.destination) {
                    case 'amplitude':
                        sendEventToAmplitudeRef.current(event.eventProps);
                        break;
                    case 'snowplow':
                        sendEventToSnowplowRef.current(event.eventProps);
                        break;
                    // case 'gtm':
                    //     sendEventToGTM(event.gtm);
                    //     break;
                    // default:
                    //     console.warn(`[Tracking] Unknown event destination: ${event.destination}`);
                }
            });
        });
    }, [setSendEvent]);

    return <></>;
};
